import { ActivityDocument, EntityType, FilterQuery, ActivityType, CRMActivityAPIPathGenerator, APIQueryParamFragments, APIResponse, CRMEntitySearchAPIPathGenerator } from "server-model";
import { CRMEntitySearchConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerCRMEntitySearchConnector extends AppServerConnector implements CRMEntitySearchConnector {
    async getSearch(organisationId: string, entityType: EntityType, search: string, start: number, limit: number): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMEntitySearchAPIPathGenerator.search(entityType),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.ORGANISATION_ID]: organisationId, [APIQueryParamFragments.SEARCH]: search, [APIQueryParamFragments.START]: start, [APIQueryParamFragments.LIMIT]: limit } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Activity not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}